/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen. & Warren Dowey
 */

import {AppDetailsModel} from '@app/models/app-details.model';

export class AppModel {
  private _appId?: string;
  private _appName?: string;
  private _appSlug?: string;
  private _ownerId?: string;
  private _appType?: number;
  private _paymentModel?: number;
  private _appLogo?: string;
  private _appDescription?: string;
  private _appStatus?: number;
  private _appIsPrivate?: boolean;
  private _createdAt?: number;
  private _updatedAt?: number;
  private _appDetails?: Map<string, AppDetailsModel>


  constructor(appId?: string, appName?: string, appSlug?: string, ownerId?: string,
              appType?: number, paymentModel?: number, appLogo?: string, appDescription?: string,
              appStatus?: number, appIsPrivate?: boolean, createdAt?: number, updatedAt?: number,
              appDetails?: Map<string, AppDetailsModel>) {
    this._appId = appId;
    this._appName = appName;
    this._appSlug = appSlug;
    this._ownerId = ownerId;
    this._appType = appType;
    this._paymentModel = paymentModel;
    this._appLogo = appLogo;
    this._appDescription = appDescription;
    this._appStatus = appStatus;
    this._appIsPrivate = appIsPrivate;
    this._createdAt = createdAt;
    this._updatedAt = updatedAt;
    this._appDetails = appDetails;
  }

  get appId(): string {
    return this._appId;
  }

  set appId(value: string) {
    this._appId = value;
  }

  get appName(): string {
    return this._appName;
  }

  set appName(value: string) {
    this._appName = value;
  }

  get appSlug(): string {
    return this._appSlug;
  }

  set appSlug(value: string) {
    this._appSlug = value;
  }

  get ownerId(): string {
    return this._ownerId;
  }

  set ownerId(value: string) {
    this._ownerId = value;
  }

  get appType(): number {
    return this._appType;
  }

  set appType(value: number) {
    this._appType = value;
  }

  get paymentModel(): number {
    return this._paymentModel;
  }

  set paymentModel(value: number) {
    this._paymentModel = value;
  }

  get appLogo(): string {
    return this._appLogo;
  }

  set appLogo(value: string) {
    this._appLogo = value;
  }

  get appDescription(): string {
    return this._appDescription;
  }

  set appDescription(value: string) {
    this._appDescription = value;
  }

  get appStatus(): number {
    return this._appStatus;
  }

  set appStatus(value: number) {
    this._appStatus = value;
  }

  get appIsPrivate(): boolean {
    return this._appIsPrivate;
  }

  set appIsPrivate(value: boolean) {
    this._appIsPrivate = value;
  }

  get createdAt(): number {
    return this._createdAt;
  }

  set createdAt(value: number) {
    this._createdAt = value;
  }

  get updatedAt(): number {
    return this._updatedAt;
  }

  set updatedAt(value: number) {
    this._updatedAt = value;
  }

  get appDetails(): Map<string, AppDetailsModel> {
    return this._appDetails;
  }

  set appDetails(value: Map<string, AppDetailsModel>) {
    this._appDetails = value;
  }

  toJson(): Object {
    const object = {
      app_id: this.appId,
      app_name: this.appName,
      app_slug: this.appSlug,
      owner_id: this.ownerId,
      app_type: this.appType,
      payment_model: this.paymentModel,
      app_logo: this.appLogo,
      app_description: this.appDescription,
      app_status: this.appStatus,
      app_is_private: this.appIsPrivate,
      created_at: this.createdAt,
      updated_at: this.updatedAt,
    };
    Object.keys(object).forEach((k) => !object[k] && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any) {
    const app_details = new Map<string, AppDetailsModel>();
    if (input['app_details'] ) {
      for (const details of input['app_details']) {
        app_details.set(input['app_id'], new AppDetailsModel().fromJson(details));
      }
    }
    return new AppModel(
      input['app_id'],
      input['app_name'],
      input['app_slug'],
      input['owner_id'],
      input['app_type'],
      input['payment_model'],
      input['app_logo'],
      input['app_description'],
      input['app_status'],
      input['app_is_private'],
      input['created_at'],
      input['updated_at'],
      app_details
    )
  }
}
